module.exports = new __parcel__URL__("testimonial-david-bellaiche-mobile.c3669d3d.webp").toString();